import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import useScrollToTop from "../../hooks/useScrollToTop";
import {
  StepBtn,
  // StepsWrapper,
  StepWrapperStyles,
} from "./stepsStyles";

const Steps = ({ children, steps, activeStep, hideSteps, setActiveStep }) => {
  const { i18n } = useTranslation();
  const history = useHistory();
  const locationSearch = history.location.search;
  const scrollToTop = useScrollToTop();

  useEffect(() => {
    const syncActiveStep = (location) => {
      if (
        `${location.pathname}/${location}`.includes(
          `/callback/${i18n.language}/${locationSearch}`
        )
      ) {
        setActiveStep(steps[1]);
        return;
      }

      steps.forEach((step) => {
        if (step.route === location.pathname) {
          setActiveStep(step);
        }
      });
    };

    syncActiveStep(history.location);

    const unlisten = history.listen((location) => {
      syncActiveStep(location);
      scrollToTop();
    });
    return unlisten;
  }, [
    history,
    i18n.language,
    locationSearch,
    scrollToTop,
    setActiveStep,
    steps,
  ]);

  if (hideSteps) return <></>;

  return (
    <>
      <div className={"btnsWrapper"}>
        {steps?.map((item) => {
          return (
            <StepWrapperStyles key={item.id} stepsLength={steps.length}>
              <div>
                <StepBtn
                  disabled={item.disabled}
                  isActive={item.id === activeStep.id}
                  passedStep={activeStep.id > item.id}
                >
                  {item.id}
                </StepBtn>
              </div>
              <div
                className={`text ${
                  item.id === activeStep.id ? "text-active" : ""
                } `}
              >
                {item.title}
              </div>
            </StepWrapperStyles>
          );
        })}
      </div>

      <div className={"content"}>
        {React.Children.map(children, (child) => (
          <div style={{ width: "835px" }}>{child}</div>
        ))}
      </div>
    </>
  );
};

export default Steps;
